module.exports = __webpack_public_path__ + "img/guangzhou_xincheng (1).17e124b0.png";